import ErrorService from "./sentry";

export default new ErrorService();
